import { FC } from "react";

import { AddRecordForm } from "../../components/AddRecordForm";

const AddRecordPage: FC = () => {
  return <AddRecordForm />;
};

export default AddRecordPage;
